import { createFileRoute } from "@tanstack/react-router";

import { AudiencesPage } from "../features/campaigns/AudiencesPage";

export const Route = createFileRoute("/app/audiences")({
  component: AudiencesPage,
});
